export { SysqueFrameModule } from './sysque-frame.module';
export { SysQuePopupComponent } from './sysque-frame.component';